import type { LoaderFunction } from 'react-router-dom';
import { apiGetBestWrestlerListStats } from "../components/ui_components/ApiList";

export const BestWrestlerResponsiveLoader: LoaderFunction = async ({ request }) => {
    try {
        const url = new URL(request.url);
        const year = url.searchParams.get('year') || 'globale';

        const response = await apiGetBestWrestlerListStats(1, year, '', true);
        return response;
    } catch (error) {
        console.error('Fallback error:', error);
        throw new Error('Failed to load data');
    }
};
